import { NewWkfApplyAdmDetailResponse, ReApplyDetailsType } from 'pages/application/reApply/type';
import { ApproverCount, IParamsSearch } from 'pages/ApprovalDocumentGroup/commonList/type';
import ApiClient from '../ApiClient';

export const getNeedRegisterListApi = async (query: IParamsSearch): Promise<{ contents: any[], currentPage: number, totalItem: number, totalPage: number }> => {
  // const { data } = await ApiClient.get('/v1/getDocNeedRegister', query);
  const { data } = await ApiClient.get('/v1/appliedDocs/needToRegister', query);
  return data;
};

export const getAppliedDocsCountApi = async (): Promise<ApproverCount> => {
  const { data } = await ApiClient.get('/v1/appliedDocs/count', {});
  return data;
};

export const getNeedApproveListApi = async (query: IParamsSearch): Promise<{ contents: any[], currentPage: number, totalItem: number, totalPage: number }> => {
  // const { data } = await ApiClient.get('/v1/getDocNeedApprove', query);
  const { data } = await ApiClient.get('/v1/appliedDocs/needToApprove', query);
  return data;
};

export const getDetailsRegisterNeed = async (applyDocId: string, isReuseDoc = false): Promise<ReApplyDetailsType> => {
  const { data } = await ApiClient.get('/v1/getDocApproval', {}, { applyDocId, isReuseDoc });
  return data;
};
export const getNewWkfApplyAdmDetailResponse = async (applyDocId: string): Promise<NewWkfApplyAdmDetailResponse> => {
  const { data } = await ApiClient.get(`/v1/wkfApplyRouteMasters/getDetailWkfApplyRouteMaster/${applyDocId}`, {}, {});
  return data;
};
export const deleteUpLoadAttachFileApi = async (wkfAttachFilePath: string) => {
  const { data } = await ApiClient.delete('/v1/wkfAttach/', { wkfAttachFilePath });
  return data;
};
export const getResultListApi = async (query: IParamsSearch): Promise<{ contents: any[], currentPage: number, totalItem: number, totalPage: number }> => {
  // const { data } = await ApiClient.get('/v1/getDocNeedApprove', query);
  const { data } = await ApiClient.get('/v1/appliedDocs/approveResult', query);
  return data;
};

export const getApprovalApplicationReferenceList = async (query: IParamsSearch): Promise<{ contents: any[], currentPage: number, totalItem: number, totalPage: number }> => {
  // const { data } = await ApiClient.get('/v1/getDocNeedApprove', query);
  const { data } = await ApiClient.get('/v1/appliedDocs/approvalApplicationReference', query);
  return data;
};


export const updateStatusDocsApi = async (wkfApplyDocIdList: string[]): Promise<any> => {
  const { data } = await ApiClient.postJsonData('/v1/wkfApplyDocStatus', {}, { wkfApplyDocIdList });
  return data;
};
